
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"action.label":"Shapefile","dialog.title":"Shapefile exportieren"},"en":{"action.label":"Shapefile","dialog.title":"Export shapefile"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();